import React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import Grid from '@mui/material/Grid';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { green } from '@mui/material/colors';
import DeleteIcon from '@mui/icons-material/Delete';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Badge from '@mui/material/Badge';
import locationDefault from '../../../../../images/locationdefault.jpg';
import GroupedButtons from '../GroupedButtons';
import { MainLocationAllocation } from '@horasys/bellplus/common/types';
import { Checkbox } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'Stores/Hooks/hooks';
import {
	CampaignState,
	addCampaignManualLocationAction,
	deleteCampaignManualLocationAction,
	updateMainLocationNoOfTimes,
	updateMainLocationSelectAllDevices,
	updateMainLocationSelectedDevices,
} from 'Stores/Slices/campaignSlice';
import { RootState } from 'Stores/store';
const PREFIX = 'LocationCardList';

const classes = {
	badge: `${PREFIX}-badge`,
	root: `${PREFIX}-root`,
	media: `${PREFIX}-media`,
	expand: `${PREFIX}-expand`,
	expandOpen: `${PREFIX}-expandOpen`,
	avatar: `${PREFIX}-avatar`,
	fabGreen: `${PREFIX}-fabGreen`,
	fabRed: `${PREFIX}-fabRed`,
	manualCalculate: `${PREFIX}-manualCalculate`,
	buttonGroup: `${PREFIX}-buttonGroup`,
	paddingSelectedDevices: `${PREFIX}-paddingSelectedDevices`,
	parentGrid: `${PREFIX}-parentGrid`,
	floatingIcon: `${PREFIX}-floatingIcon`,
	locationGrid: `${PREFIX}-locationGrid`,
};

const Root = styled('div')(({ theme }) => ({
	[`& .${classes.root}`]: {
		maxWidth: 345,
		minWidth: 300,
	},

	[`& .${classes.media}`]: {
		height: 150,
		paddingTop: '56.25%', // 16:9
	},

	[`& .${classes.expand}`]: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest,
		}),
	},

	[`& .${classes.expandOpen}`]: {
		transform: 'rotate(180deg)',
	},

	[`& .${classes.avatar}`]: {
		backgroundColor: red[500],
	},

	[`& .${classes.fabGreen}`]: {
		marginTop: theme.spacing(1),
		color: theme.palette.common.white,
		backgroundColor: green[500],
		'&:hover': {
			backgroundColor: green[600],
		},
	},

	[`& .${classes.fabRed}`]: {
		marginTop: theme.spacing(1),
		color: theme.palette.common.white,
		backgroundColor: red[500],
		'&:hover': {
			backgroundColor: red[600],
		},
	},

	[`& .${classes.manualCalculate}`]: {
		marginTop: theme.spacing(3),
	},

	[`& .${classes.buttonGroup}`]: {
		marginTop: theme.spacing(1),
	},

	[`& .${classes.paddingSelectedDevices}`]: {
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		paddingTop: theme.spacing(1),
	},

	[`& .${classes.parentGrid}`]: {
		padding: theme.spacing(3),
	},

	[`& .${classes.floatingIcon}`]: {
		position: 'fixed',
		bottom: theme.spacing(10),
		right: theme.spacing(10),
		backgroundColor: '#042630',
		color: '#fff',
	},

	[`& .${classes.locationGrid}`]: {
		padding: theme.spacing(3),
	},
}));

/**
 * Displaying for location name and its devices. used in manual mode of slot allocation.
 * @param {*} param0
 */

export default function LocationDetails({
	handleSlotBookHandler,
	modalDialogViewMode,
}: {
	handleSlotBookHandler: any;
	modalDialogViewMode: any;
}) {
	const campaignStore: CampaignState = useAppSelector(
		(state: RootState) => state.campaign,
	);
	const locationData = campaignStore.campaignAdvertisementForm.searchLocations;
	const dispatch = useAppDispatch();

	const handleAddLocation = (loc: MainLocationAllocation) => {
		dispatch(addCampaignManualLocationAction(loc));
	};

	const handleDeleteLocation = (loc: MainLocationAllocation) => {
		dispatch(deleteCampaignManualLocationAction(loc));
	};
	const bookSlotsHandler = () => {
		handleSlotBookHandler(locationData);
	};

	const handleNoOfTimesChange = (loc: MainLocationAllocation, count: any) => {
		dispatch(updateMainLocationNoOfTimes(loc, count));
	};

	const handleSelectedDevicesChange = (loc: any, count: any) => {
		dispatch(updateMainLocationSelectedDevices(loc, count));
	};

	return (
		<Root>
			<Grid container xs={12} className={classes.parentGrid}>
				{locationData && locationData.length > 0 && false && (
					<Grid container xs={12}>
						<Grid item xs={8}>
							<Typography variant="h1" align="center">
								Choose Devices
							</Typography>
						</Grid>
						<Grid item xs={4}>
							<IconButton aria-label="cart" size="large">
								<StyledBadge
									badgeContent={0}
									color="secondary"
									classes={{
										badge: classes.badge,
									}}>
									<ShoppingCartIcon />
								</StyledBadge>
							</IconButton>
						</Grid>
					</Grid>
				)}

				{locationData &&
					locationData.length > 0 &&
					locationData.map((loc: MainLocationAllocation, index: number) => (
						<Grid item xs={3} className={classes.locationGrid} key={index}>
							<Card className={classes.root}>
								<CardHeader
									avatar={
										<Avatar
											aria-label="location"
											className={classes.avatar}>
											{loc.name.charAt(0)}
										</Avatar>
									}
									title={loc.name}
									subheader={loc.description}
								/>
								<CardMedia
									className={classes.media}
									image={loc.asset ? loc.asset : locationDefault}
									title={loc.name}
								/>
								<CardContent>
									{loc.availableDevices > 0 ? (
										<>
											<Grid container xs={12}>
												<Grid
													container
													item
													xs={12}
													className={classes.buttonGroup}>
													<Grid item container xs={6}>
														<Typography
															variant="subtitle2"
															component="h6">
															Total Devices :
														</Typography>
													</Grid>
													<Grid item container xs={6}>
														<Typography
															variant="subtitle2"
															component="h6">
															{loc.totalDevices}
														</Typography>
													</Grid>
												</Grid>
												<Grid
													container
													item
													xs={12}
													className={classes.buttonGroup}>
													<Grid item container xs={6}>
														<Typography
															variant="subtitle2"
															component="h6">
															Available Devices :
														</Typography>
													</Grid>
													<Grid item container xs={6}>
														<Typography
															variant="subtitle2"
															component="h6">
															{loc.availableDevices}
														</Typography>
													</Grid>
												</Grid>
												<Grid
													container
													item
													xs={12}
													className={classes.buttonGroup}>
													<Grid item container xs={6}>
														<Typography
															variant="subtitle2"
															component="h6">
															Selected Devices :
														</Typography>
													</Grid>
													<Grid item container xs={6}>
														<Typography
															variant="subtitle2"
															component="h6">
															<GroupedButtons
																initialValue={
																	loc.selectedDevices
																		? loc.selectedDevices
																		: 1
																}
																maxValue={
																	loc.availableDevices
																}
																minValue={1}
																handleChange={(
																	count: any,
																) => {
																	handleSelectedDevicesChange(
																		loc,
																		count,
																	);
																}}
															/>
														</Typography>
													</Grid>
													<Grid item xs={6}></Grid>
													<Checkbox
														style={{
															marginLeft: '-10px',
															color: '#042630',
															opacity: 0.6,
														}}
														checked={loc.selectAllDevices}
														onChange={() =>
															dispatch(
																updateMainLocationSelectAllDevices(
																	loc,
																),
															)
														}
														inputProps={{
															'aria-label':
																'primary checkbox',
														}}
													/>
													<Typography style={{ marginTop: 10 }}>
														Select all
													</Typography>
												</Grid>
												<Grid
													container
													item
													xs={12}
													className={classes.buttonGroup}>
													<Grid item container xs={6}>
														<Typography
															variant="subtitle2"
															component="h6">
															No. of times :
														</Typography>
													</Grid>
													<Grid item container xs={6}>
														<Typography
															variant="subtitle2"
															component="h6">
															<GroupedButtons
																initialValue={
																	loc.noOfTimes
																		? loc.noOfTimes
																		: 1
																}
																maxValue={5}
																minValue={1}
																handleChange={(
																	count: any,
																) => {
																	handleNoOfTimesChange(
																		loc,
																		count,
																	);
																}}
															/>
														</Typography>
													</Grid>
												</Grid>
											</Grid>
										</>
									) : (
										<Typography> No available devices </Typography>
									)}
								</CardContent>
								<CardActions disableSpacing>
									<>
										<Grid container justifyContent="center" xs={12}>
											{!loc.added ? (
												<Fab
													size="small"
													color="primary"
													disabled={modalDialogViewMode}
													className={classes.fabGreen}
													aria-label="add"
													onClick={() => {
														handleAddLocation(loc);
													}}>
													<AddIcon />
												</Fab>
											) : (
												<Fab
													size="small"
													color="primary"
													disabled={modalDialogViewMode}
													className={classes.fabRed}
													aria-label="add"
													onClick={() => {
														handleDeleteLocation(loc);
													}}>
													<DeleteIcon />
												</Fab>
											)}
										</Grid>
									</>
								</CardActions>
							</Card>
						</Grid>
					))}
			</Grid>
			{locationData && locationData.length > 0 && (
				<Fab
					variant="extended"
					aria-label="add"
					disabled={modalDialogViewMode}
					className={classes.floatingIcon}
					onClick={bookSlotsHandler}>
					Book Slot
				</Fab>
			)}
		</Root>
	);
}

const StyledBadge = Badge;
